import {REGISTRY_SINGLETON} from '../../scenes/Registry';
import {playUnitDeathEffects} from '../../scenes/playUnitDeathEffects';
import {selectCombatResults} from '../reducers/sharedStateReducer/selectors';
import {checkIfReplayRewinding} from '../../utils/replay/replayPlaybackSpeed';

// Полное состояние (переподключение, ресинк) гибель заново не показывает — как и модалку
// итогов боя в modalsMiddleware
const IGNORED_ACTIONS = ['LOAD_STATE', 'RESET_STATE'];

/**
 * Гибель отрядов запускается здесь — сразу после того, как новые итоги боя прошли
 * редьюсер, какой бы путь их ни принес: свой ход, сервер, бот или запись матча.
 *
 * Стоит в цепочке ПОСЛЕ modalsMiddleware: та поднимает флаг модалки, когда управление
 * вернется к ней из next, — а к этому моменту гибель уже подняла свой, и модалка ни на
 * кадр не покажется раньше нее. Анимации нет (скрытая вкладка, перемотка, отряд вне
 * кадра) — модалка показывается сразу, как раньше.
 */
export const createUnitDeathAnimationMiddleware = ({getHexGridRenderer, play = playUnitDeathEffects}) => (
  (store) => (next) => (action) => {
    if (!action || IGNORED_ACTIONS.includes(action.type)) {
      return next(action);
    }

    const previousCombatResults = selectCombatResults(store.getState());
    const result = next(action);
    const combatResults = selectCombatResults(store.getState());

    if (combatResults?.length > 0 && combatResults !== previousCombatResults && !checkIfReplayRewinding()) {
      const hexGridRenderer = getHexGridRenderer();
      if (hexGridRenderer) {
        try {
          play(store, hexGridRenderer, combatResults);
        } catch (error) {
          // Анимация — украшение: ее поломка не должна ронять диспатч
          console.warn('[UnitDeath] не удалось показать гибель отрядов', error);
        }
      }
    }

    return result;
  }
);

const unitDeathAnimationMiddleware = createUnitDeathAnimationMiddleware({
  getHexGridRenderer: () => REGISTRY_SINGLETON.getHexGridRenderer(),
});

export default unitDeathAnimationMiddleware;
